import { useNavigate } from "react-router-dom";
import AppFooter from "../components/AppFooter";

const SECTIONS = [
    { label: "AI — Brain / Body / Adoption-Application", date: "05.29.2026", updated: "06.18.2026", path: "/reference", testId: "index-nav-reference" },
    { label: "Small Cap Positioning via CoT Report", date: "06.15.2026", path: "/cot", testId: "index-nav-cot" },
    { label: "Treasury Curve Positioning", date: "06.17.2026", path: "/treasury", testId: "index-nav-treasury" },
    { label: "Weekly Positioning — CoT Reports", date: "06.26.2026", path: "/positioning", testId: "index-nav-positioning", highlight: true },
];

export default function IndexPage() {
    const navigate = useNavigate();

    return (
        <div data-testid="index-page" style={{ minHeight: "100vh", background: "var(--pord-bg, #222518)" }}>
            <div style={{ maxWidth: 960, width: "100%", margin: "0 auto", padding: "80px 24px 60px" }}>
                <div className="pord-eyebrow" style={{ marginBottom: 56 }}>Pord.</div>

                <div>
                    {SECTIONS.map((section, i) => (
                        <button key={section.path} data-testid={section.testId}
                            onClick={() => navigate(section.path)}
                            style={{
                                display: "flex", alignItems: "baseline", width: "100%", textAlign: "left",
                                background: section.highlight ? "rgba(218,242,208,0.03)" : "none",
                                border: "none", borderBottom: "1px solid rgba(184,212,208,0.10)",
                                padding: "20px 0", cursor: "pointer", transition: "background-color 200ms ease", gap: 16,
                                ...(section.highlight ? { boxShadow: "0 0 24px rgba(218,242,208,0.06), inset 0 0 20px rgba(218,242,208,0.02)" } : {}),
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = section.highlight ? "rgba(218,242,208,0.06)" : "rgba(184,212,208,0.03)"; }}
                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = section.highlight ? "rgba(218,242,208,0.03)" : "transparent"; }}
                        >
                            <span style={{
                                fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 300,
                                color: section.highlight ? "#DAF2D0" : "var(--pord-sage, #9aada8)",
                                letterSpacing: "0.04em", flexShrink: 0, width: 28,
                                ...(section.highlight ? { textShadow: "0 0 12px rgba(218,242,208,0.5)" } : {}),
                            }}>
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <span className="pord-heading" style={{
                                fontSize: "clamp(16px, 2.2vw, 20px)",
                                color: section.highlight ? "#DAF2D0" : "#ffffff",
                                flex: 1,
                                ...(section.highlight ? { textShadow: "0 0 16px rgba(218,242,208,0.35)" } : {}),
                            }}>
                                {section.label}
                            </span>
                            <span style={{
                                fontFamily: "'DM Sans', sans-serif", fontSize: 12, fontWeight: 300,
                                color: "var(--pord-text-dim, rgba(255,255,255,0.38))", letterSpacing: "0.06em",
                                flexShrink: 0, whiteSpace: "nowrap", textAlign: "right",
                            }}>
                                {section.date}
                                {section.updated && (
                                    <><br /><span style={{ color: "var(--pord-sage, #9aada8)", fontSize: 11 }}>updated {section.updated}</span></>
                                )}
                            </span>
                        </button>
                    ))}
                </div>
                <AppFooter />
            </div>
        </div>
    );
}
